import { render, staticRenderFns } from "./Nachrichten.vue?vue&type=template&id=fa368d22&"
import script from "./Nachrichten.vue?vue&type=script&lang=js&"
export * from "./Nachrichten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports